import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

import type { GlossaryCategoryItem, GlossaryResponse } from '@/entities/glossary/domain';

type GetGlossaryCategoryParams = {
  limit?: number;
  after?: string;
};

export type GetGlossaryCategoryResponse = GlossaryResponse<GlossaryCategoryItem>;

export const getGlossaryCategoryApi = async ({ limit = 3000 }: GetGlossaryCategoryParams) => {
  const { data } = await openMetadataApiClient.get<GetGlossaryCategoryResponse>('/glossaries', {
    params: {
      limit,
      fields: 'owners,tags,reviewers,votes,domains,termCount',
    },
  });
  return data;
};
